<div class="dialog-container">
    <header class="dialog-header p-lr20 p-t20" >
        <div  class="flex-row-container">    
            <!-- <span *ngIf="mode==='edit'" class="flex-1 B font18">Edit Income - <span class="blueText18">{{income.incDesc}}</span></span>
            <span *ngIf="mode==='add'" class="flex-1 B font18">Add Income - <span class="blueText18">{{income.incDesc}}</span></span> -->
            <span *ngIf="mode==='edit'" class="flex-1 B font18">Edit Income</span>
            <span *ngIf="mode==='add'" class="flex-1 B font18">Add Income</span>
            <!-- <span class="water-mark m-r25">DRAFT</span> -->
            <mat-icon class="pointer" aria-hidden="false" (click)="closeDialog(false)">close</mat-icon>
        </div>    
    </header>
    <main class="dialog-content m-10" style="background-color: white;">
        <form [formGroup]="form">
            <section class="m-25 p-10 flex-col-container">
                <header class="cf-header">
                  <div class="cf-col gray-text font12 B">INCOME</div>
                  <div class="cf-col gray-text font12 B m-l50">INCOME TYPE</div>
                  <div class="cf-col gray-text font12 B">OWNER</div>                  
                </header>
                <div class="cf-row">
                  <div class="cf-col">
                    <mat-form-field style="width:90%;">
                      <input matInput type="text" [formControlName]="'incDesc'" 
                        placeholder="" 
                        aria-label="Income" 
                        maxlength="30"                    
                        />
                    </mat-form-field>
                    <span class="validationError" *ngIf="form.hasError('required', 'incDesc') && form.controls?.incDesc.touched">*</span> 
                  </div>
                  <div class="cf-col m-l50">
                    <mat-form-field style="width:150px">
                      <mat-select [formControlName]="'incType'">
                      <mat-option *ngFor="let iType of incomeTypes" [value]="iType.code" (onSelectionChange)="selectIncomeType($event, iType.code)">
                          {{iType.value}}
                      </mat-option>
                      </mat-select>
                    </mat-form-field>   
                  </div>               
                  <div class="cf-col font18">
                    <mat-form-field style="width:150px">
                      <mat-select [formControlName]="'owner'">
                      <mat-option *ngFor="let iOwner of incomeOwners" [value]="iOwner.clientid">
                          {{iOwner.clientname}}
                      </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>                  
                </div>
            </section>  

            <section class="m-25 p-10 flex-col-container">
                <header class="cf-header">
                  <div class="cf-col gray-text font12 B">
                    <span *ngIf="form.get('incType').value==='SS'">BENEFIT START AGE</span>
                    <span *ngIf="form.get('incType').value!=='SS'">DURATION START</span>
                  </div>
                  <div class="cf-col gray-text font12 B m-l50">DURATION END</div>
                  <div class="cf-col gray-text font12"><span class="B">INCOME</span>
                    <mat-button-toggle-group class="m-l10" [formControlName]="'isMonthly'">
                      <mat-button-toggle color="primary" class="font14" style="width:75px" value='true' (click)="selectIncomeFreqType('true')">Monthly</mat-button-toggle>
                      <mat-button-toggle color="primary" class="font14" style="width:75px" value='false' (click)="selectIncomeFreqType('false')">Yearly</mat-button-toggle>
                    </mat-button-toggle-group>
                  </div>
                </header>
                <div class="cf-row">
                  <div class="cf-col">
                    <div class="" >
                        <mat-form-field style="width:150px" *ngIf="form.get('incType').value!=='SS'">
                            <mat-select [formControlName]="'startType'">
                            <mat-option *ngFor="let sType of startTypes" [value]="sType.code" (onSelectionChange)="selectYearType($event, sType.code, 'start')">
                                {{sType.value}}
                            </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="m-l10" style="width:45px;" *ngIf="form.get('startType').value ==='Year'">
                            <input matInput type="text" [formControlName]="'startYr'"
                                placeholder="Year" 
                                aria-label="" 
                                maxlength="4"                      
                                NumbersOnly
                                class="ip-right-align"/>                
                        </mat-form-field>
                        <mat-form-field class="m-l10" style="width:45px;" *ngIf="form.get('startType').value ==='Age'">
                            <input matInput type="text" [formControlName]="'startAge'"
                                [placeholder]="form.get('incType').value!=='SS'?'Age':''" 
                                aria-label="" 
                                maxlength="3"                      
                                NumbersOnly
                                class="ip-right-align"/>
                                <!-- <mat-hint *ngIf="form.get('incType').value==='SS'" align="end">62-70</mat-hint>                                              -->
                        </mat-form-field>   
                          <!-- <span class="validationError" *ngIf="form.hasError('required', 'startYr') && form.controls?.startYr.touched">*</span>                           -->
                          <span class="validationError" *ngIf="form.hasError('required', 'startYr') && form.controls?.startYr.touched">*</span>                          
                          <span class="validationError" *ngIf="form.hasError('required', 'startAge') && form.controls?.startAge.touched">*</span>                          
                    </div>
                  </div>                  
                  <div class="cf-col m-l50">
                    <div class="font16 m-b20" *ngIf="form.get('incType').value==='SS'">
                      Rest of Life
                    </div>
                    <div class="" *ngIf="form.get('incType').value!=='SS'">
                      <mat-form-field style="width: 150px">
                          <mat-label></mat-label>
                          <mat-select [formControlName]="'endType'">
                          <mat-option *ngFor="let eType of endTypes" [value]="eType.code" (onSelectionChange)="selectYearType($event, eType.code, 'end')">
                              {{eType.value}}
                          </mat-option>
                          </mat-select>
                      </mat-form-field>
                      <mat-form-field class="m-l10" style="width:45px;" *ngIf="form.get('endType').value ==='Year'" >
                          <input matInput type="text" [formControlName]="'endYr'"
                              placeholder="Year" 
                              aria-label="" 
                              maxlength="4"                      
                              NumbersOnly
                              class="ip-right-align"
                              />                
                      </mat-form-field>
                      <mat-form-field class="m-l10" style="width:45px;" *ngIf="form.get('endType').value ==='Age'">
                          <input matInput type="text" [formControlName]="'endAge'"
                              placeholder="Age" 
                              aria-label="" 
                              maxlength="3"                      
                              NumbersOnly
                              class="ip-right-align"/>                                                                   
                      </mat-form-field>   
                      <mat-form-field class="m-l10" style="width:45px;" *ngIf="form.get('endType').value ==='Duration'">
                        <input matInput type="text" [formControlName]="'duration'"
                            placeholder="Years" 
                            aria-label="" 
                            maxlength="3"                      
                            NumbersOnly
                            class="ip-right-align"/>                                                                   
                      </mat-form-field>  
                      <span class="validationError" *ngIf="form.hasError('required', 'endYr') && form.controls?.endYr.touched">*</span>                       
                      <span class="validationError" *ngIf="form.hasError('required', 'endAge') && form.controls?.endAge.touched">*</span>                       
                      <span class="validationError" *ngIf="form.hasError('required', 'duration') && form.controls?.duration.touched">*</span>                       

                      <!-- <span class="validationError" *ngIf="form.hasError('required', 'endAge') && form.controls?.endAge.touched">*</span>                        -->
                    </div>
                  </div>                  
                  <div class="cf-col">
                    <mat-form-field style="width:200px;">
                        <input matInput type="text" [formControlName]="'amount'" 
                            placeholder="" 
                            aria-label=""                                          
                            class="ip-right-align p-r5"/>                
                    </mat-form-field>
                    <span class="validationError" *ngIf="form.hasError('required', 'amount') && form.controls?.amount.touched">*</span>                                         
                    <p *ngIf="form.get('incType').value==='SS'"  style="margin-top:-5px" class="font14 text-blue"><a href="https://www.ssa.gov/OACT/quickcalc/index.html" target="_blank">Estimate Social Security @ ssa.gov</a></p>                    
                  </div>
                </div>
            </section>
            
            <section class="m-25 p-10 flex-col-container">
                <header class="cf-header">
                  <div class="cf-col gray-text font12 B">ANNUAL INFLATION</div>
                  <div class="cf-col gray-text font12 B m-l50">TAXABLE</div>
                  <div class="cf-col gray-text font12 B">ADJUST TO FUTURE DOLLARS</div>
                </header>
                <div class="cf-row">
                  <div class="cf-col">
                    <mat-button-toggle-group class="" style="width:239px" [formControlName]="'growthType'">
                      <mat-button-toggle color="primary" class="font14" style="width:120px" value='INF' (click)="selectGrowthType('INF')"><span class="">Inflation: </span><span [ngClass]="form.get('growthType').value ==='INF'?'B':''">{{infRate | number : '1.2-2' }}%</span></mat-button-toggle>
                      <mat-button-toggle color="primary" class="font14" style="width:120px" value='MNF' (click)="selectGrowthType('MNF')"><span class="m-r5">Custom</span></mat-button-toggle>
                    </mat-button-toggle-group>
                    <mat-form-field class="m-b2 m-l3" 
                      [ngStyle]="{'visibility': form.get('growthType').value === 'MNF'? 'visible': 'hidden'}"
                      style="width:60px;  border-top:0px !important; font-size: 14px;">
                      <span matSuffix>%</span>
                      <input matInput type="text" [formControlName]="'growthRate'" 
                        placeholder="" 
                        aria-label="Annual Inflation" 
                        maxlength="6"  
                        decimals="2"                  
                        NumbersOnly                        
                        class="ip-right-align"/>                
                    </mat-form-field>  
                    <span class="m-l3 validationError" *ngIf="form.hasError('required', 'growthRate') && form.controls?.growthRate.touched">*</span>                                                                    
                  </div>  
                  <div class="cf-col m-l50">
                    <mat-button-toggle-group class="" style="width:99px" [formControlName]="'isTaxable'">
                      <mat-button-toggle color="primary" class="font14" style="width:50px" value='true'>Yes</mat-button-toggle>
                      <mat-button-toggle color="primary" class="font14" style="width:50px" value='false'>No</mat-button-toggle>
                    </mat-button-toggle-group>
                    <mat-form-field style = "visibility: hidden">
                      <input matInput type="text"/> 
                    </mat-form-field>                                                              
                  </div>  
                  <div class="cf-col">
                    <!-- <mat-checkbox  [formControlName]="'isAdjToFutureDollar'" (change)="selectTaxable()">Adjust to future dollars</mat-checkbox> -->
                    <mat-button-toggle-group class="" style="width:99px" [formControlName]="'isAdjToFutureDollar'">
                      <mat-button-toggle color="primary" class="font14" style="width:50px" value='true'>Yes</mat-button-toggle>
                      <mat-button-toggle color="primary" class="font14" style="width:50px" value='false'>No</mat-button-toggle>
                    </mat-button-toggle-group>
                    <mat-form-field style = "visibility: hidden">
                      <input matInput type="text"/> 
                    </mat-form-field>  
                  </div>
                </div>
            </section>

    
        </form>
    
    </main>
    <footer class="flex-col-end m-10">
        <mat-divider class="divider" style="width: 98%"></mat-divider>
        <div class="flex-row-container m-t15">
            <span class="m-r25 error align-self">{{validationMsg}}</span>
            <button mat-button color="primary" (click)="closeDialog(false)">Cancel</button>
            <button *ngIf="mode==='edit'" class="m-lr10" mat-raised-button color="primary" (click)="deleteIncome()">Delete</button>
            <button class="m-lr10" mat-raised-button [disabled]="!form.valid" color="primary" (click)="saveIncome()">Save</button>
        </div>
    </footer>
  </div>


    <!-- <mat-radio-group class="flex-col-container" aria-labelledby="ANNUAL INFLATION"
                      [formControlName]="'growthType'" >
                      <mat-radio-button class="m-t20" value="INF" (change)="selectGrowthType('INF')">
                        <span class="m-r17">Inflation: </span><span>{{infRate | number : '1.2-2' }}%</span>  
                      </mat-radio-button> 
                      <mat-radio-button style="margin-top:-5px;" value="MNF" (change)="selectGrowthType('MNF')">
                        <div class="flex-row-end">
                          <span class="m-r5">Manual:</span> 
                          <mat-form-field class="m-b2" style="width:60px; font-size: 14px;">
                            <span matSuffix>%</span>
                            <input matInput type="text" [formControlName]="'growthRate'" 
                                placeholder="" 
                                aria-label="Annual Inflation" 
                                maxlength="6"  
                                decimals="2"                  
                                NumbersOnly
                                class="ip-right-align"/>                
                          </mat-form-field>  
                          <span class="m-l3 validationError" *ngIf="form.hasError('required', 'growthRate') && form.controls?.growthRate.touched">*</span>                          
                        </div>
                      </mat-radio-button>
                    </mat-radio-group>     -->